


























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Element, ElementPatch, NewElement, Product, SearchProductOptions, CvValue, SearchElementOptions, ElementType } from '@/models'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { CV_VALUE_ELEMENT_RELATION_TYPE, CV_VALUE_TYPE_ELEMENT_EC, CV_VALUE_VIEWER_TYPE, CV_VALUE_QUARTER, CV_VALUE_CONCEPT_ICONS, CV_VALUE_REGION, CV_VALUE_TYPE_PROD } from '@/utils/constants'
import ApiClient from '@/services/api-client'
import { Utils } from '@/utils'
import { ActionTypes } from '@/store/action-types'
import { CvValueUtils } from '@/utils/cv-value-utils'
import moment from 'moment'
import { MutationTypes } from '@/store/mutation-types'

@Component({
  components: {
    ModalInfoHeader: () => import('@/containers/ModalInfoHeader.vue')
  }
})
export default class UpsertElementModal extends Vue {
  @Prop({ required: true }) selectedParent: Product | Element
  @Prop({ required: false }) elementUpdate: Element
  @Prop({ required: true, type: Object }) readonly product: Product

  public FIELD_ELEMENT_RELATION_PRODUCT = 'elementRelationProduct'
  public FIELD_ELEMENT_RELATION_ELEMENT = 'elementRelationElement'
  public FIELD_ORIGIN_CODSAP_WEBPACK = 'originCodsapWebpack'
  public FIELD_ORIGIN_ELEMENT_WEBPACK = 'originElementWebpack'
  public FIELD_ORIGIN_CODSAP_COVER_WEBPACK = 'originCodsapCoverWebpack'

  private originCodsapWebpackSearchArray: Product[] = []
  private originElementWebpackSearchArray: Element[] = []
  private originCodsapCoverWebpackSearchArray: Product[] = []

  private productRelationSearch: number | null = null
  private productRelationSearchArray: Product[] = []
  private elementRelationSearchArray: Element[] = []
  private cvElementRelation: CvValue[] = []
  private visibleMetadata = true
  private visibleNamingArchive = true
  private visibleRelation = false

  private regexCode = /^[A-Za-z0-9]+$/

  private newElement: NewElement = {
    name: '',
    type: '',
    code: null,
    elementRelationTo: null,
    elementRelationType: '',
    elementRelationPercentage: null,
    metadata: {}
  }

  private productTypes: CvValue[] = []
  private typeElementsEc: CvValue[] = []
  private viewerTypes: CvValue[] = []
  private quarters: CvValue[] = []
  private regions: CvValue[] = []
  private conceptIcons: CvValue[] = []

  private formOk(): boolean {
    return !!this.newElement.name && !!this.newElement.type && this.codeState
  }

  get availableTypes() {
    if (Utils.isProduct(this.selectedParent)) {
      const productTypeParent = this.productTypes.find((item: CvValue) => item.codeId === this.selectedParent.type)
      if (!productTypeParent) {
        return []
      }

      let childrenAvailableTypesArray: string[] = []
      if (productTypeParent.childrenElementTypeAllowed) {
        childrenAvailableTypesArray = productTypeParent.childrenElementTypeAllowed.split(',')
      }
      if (childrenAvailableTypesArray.length < 1) {
        return []
      }

      return [
        { codeId: '', name: this.$i18n.t('upsert_element_modal_component.type_placeholder') },
        ...this.$store.getters.elementTypes.filter((item: ElementType) => childrenAvailableTypesArray.includes(item.codeId))
      ]
    } else {
      const elementTypeParent = this.$store.getters.elementTypes.find((item: ElementType) => item.codeId === this.selectedParent.type)
      if (!elementTypeParent) {
        return []
      }

      let childrenAvailableTypesArray: string[] = []
      if (elementTypeParent.childrenElementTypeAllowed) {
        childrenAvailableTypesArray = elementTypeParent.childrenElementTypeAllowed.split(',')
      }
      if (childrenAvailableTypesArray.length < 1) {
        return []
      }

      return [
        { codeId: '', name: this.$i18n.t('upsert_element_modal_component.type_placeholder') },
        ...this.$store.getters.elementTypes.filter((item: ElementType) => childrenAvailableTypesArray.includes(item.codeId))
      ]
    }
  }

  get typeSelected() {
    if (this.newElement.type === '') {
      return null
    }
    return this.$store.getters.elementTypes.find((item: ElementType) => item.codeId === this.newElement.type)
  }

  get typeElementsEcFiltered() {
    if (this.typeElementsEc && this.product.editorialProject && this.product.editorialProject !== '') {
      return this.typeElementsEc.filter((typeElementEc: CvValue) => typeElementEc.editorialProjectsId?.split(',').includes(this.product.editorialProject as string))
    }
    return this.typeElementsEc
  }

  get isFirstLevel() {
    return Utils.isProduct(this.selectedParent)
  }

  get codeState(): boolean {
    return (this.newElement.code == null || this.newElement.code === '') || this.regexCode.test(this.newElement.code)
  }

  get isNewElement() {
    return !(this.elementUpdate != null && this.elementUpdate.id != null)
  }

  @Watch('elementUpdate', { deep: true })
  onElementUpdateChanged() {
    this.resetForm()
  }

  @Watch('typeSelected', { deep: true })
  onElementTypeChanged(val: ElementType) {
    this.autoCompleteName(val)
    this.autoCompleteCode()
    this.resetMetadata(true)
  }

  created() {
    this.loadProductTypes()
    this.loadCvValuesElement()
    this.loadElementRelationType()
    this.loadTypeElementsEc()
    this.loadViewerTypes()
    this.loadQuarters()
    this.loadRegions()
    this.loadConceptIcons()
  }

  private async loadProductTypes() {
    this.productTypes = await CvValueUtils.getCvValuesByType(CV_VALUE_TYPE_PROD)
  }

  private async loadTypeElementsEc() {
    this.typeElementsEc = await CvValueUtils.getCvValuesByType(CV_VALUE_TYPE_ELEMENT_EC)
  }

  private async loadViewerTypes() {
    this.viewerTypes = await CvValueUtils.getCvValuesByType(CV_VALUE_VIEWER_TYPE)
  }

  private async loadQuarters() {
    this.quarters = await CvValueUtils.getCvValuesByType(CV_VALUE_QUARTER)
  }

  private async loadRegions() {
    this.regions = await CvValueUtils.getCvValuesByType(CV_VALUE_REGION)
  }

  private async loadConceptIcons() {
    this.conceptIcons = await CvValueUtils.getCvValuesByType(CV_VALUE_CONCEPT_ICONS)
  }

  openModal() {
    this.resetForm()
  }

  hideModal() {
    this.clearForm()
    this.$bvModal.hide('upsertElementModal')
  }

  private resetForm() {
    this.clearForm()

    if (!this.isNewElement) {
      this.newElement.name = this.elementUpdate.name
      this.newElement.type = this.elementUpdate.type
      this.newElement.code = this.elementUpdate.code
      if (this.isFirstLevel && this.newElement.code && this.typeSelected.codeTemplate && this.typeSelected.codeTemplate !== '') {
        const partsCode = this.newElement.code.split(this.typeSelected.codeTemplate)
        if (partsCode.length > 1) {
          this.newElement.code = partsCode[1]
        }
      }
      this.newElement.elementRelationTo = this.elementUpdate.elementRelationTo
      if (this.elementUpdate.elementRelationToProductCodsap) {
        this.loadProductRelationSearchArray(this.elementUpdate.elementRelationToProductCodsap)
      }
      if (this.elementUpdate.elementRelationTo) {
        this.loadElementRelationSearchArray(this.elementUpdate.elementRelationTo.toString())
      }
      this.newElement.elementRelationType = this.elementUpdate.elementRelationType
      this.newElement.elementRelationPercentage = this.elementUpdate.elementRelationPercentage

      const metadata = Object.assign({}, this.newElement.metadata, this.elementUpdate.metadata)
      Vue.set(this.newElement, 'metadata', metadata)

      if (this.newElement.metadata && this.newElement.metadata.originCodsapWebpack) {
        this.loadOriginCodsapWebpackSearchArray(this.newElement.metadata.originCodsapWebpack)
      }
      if (this.newElement.metadata && this.newElement.metadata.originElementWebpack) {
        this.loadOriginElementWebpackSearchArray(this.newElement.metadata.originElementWebpack)
      }
      if (this.newElement.metadata && this.newElement.metadata.originCodsapCoverWebpack) {
        this.loadOriginCodsapCoverWebpackSearchArray(this.newElement.metadata.originCodsapCoverWebpack)
      }
    } else {
      if (this.availableTypes.length === 2) {
        this.newElement.type = this.availableTypes[1].codeId
      }
    }
  }

  private autoCompleteName(elementType: ElementType) {
    if (elementType && elementType.nameTemplate !== undefined && elementType.nameTemplate !== '' && this.newElement.name === '') {
      this.newElement.name = elementType.nameTemplate
    }
  }

  private autoCompleteCode() {
    if (this.typeSelected && !this.typeSelected.autoGenerateCode && this.newElement.code == null) {
      this.newElement.code = this.typeSelected.codeTemplate
    }
  }

  private getElementCode() {
    if (this.isFirstLevel) {
      return this.typeSelected.codeTemplate + this.newElement.code
    }
    return this.newElement.code
  }

  private loadCvValuesElement() {
    this.$store.dispatch(ActionTypes.LOAD_ELEMENT_TYPES)
  }

  private async loadElementRelationType() {
    this.cvElementRelation = await CvValueUtils.getCvValuesByType(CV_VALUE_ELEMENT_RELATION_TYPE)
  }

  private upsertElement(): void {
    if (this.elementUpdate != null && this.elementUpdate.id != null) {
      this.updateElement()
    } else {
      this.insertElement()
    }
  }

  private updateElement() {
    if (this.formOk()) {
      const updateElement: ElementPatch = {
        name: this.newElement.name,
        type: this.newElement.type,
        code: this.getElementCode(),
        elementRelationTo: this.newElement.elementRelationTo,
        elementRelationType: this.newElement.elementRelationType,
        elementRelationPercentage: this.newElement.elementRelationPercentage,
        metadata: this.getMetadataForSave()
      }
      this.$store.commit(MutationTypes.SET_LOADING, true)
      ApiClient.updateElement(updateElement, this.elementUpdate.id)
        .then((element: Element) => {
          this.$emit('elementUpdated', element)
          this.hideModal()
          this.clearForm()
          this.$store.dispatch(ActionTypes.SHOW_TOAST, {
            title: this.$t('upsert_element_modal_component.title_edit'),
            variant: 'success',
            message: this.$t('upsert_element_modal_component.feedback.success_update') + ` ${element.name}`
          })
          this.$store.commit(MutationTypes.SET_LOADING, false)
        })
        .catch((ex) => {
          this.$store.dispatch(ActionTypes.SHOW_TOAST, {
            title: this.$t('upsert_element_modal_component.title_edit'),
            variant: 'danger',
            message: `${ex.response.data.message}`
          })
          this.$store.commit(MutationTypes.SET_LOADING, false)
        })
    } else {
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('upsert_element_modal_component.title_edit'),
        variant: 'danger',
        message: this.$t('feedback.error_message_generic')
      })
    }
  }

  private insertElement() {
    if (this.formOk()) {
      this.$store.commit(MutationTypes.SET_LOADING, true)
      const productCode = this.getProductCode()
      const parentElementId = this.getParentElementId()
      const newElement = Object.assign({}, this.newElement)
      newElement.code = this.getElementCode()
      newElement.metadata = this.getMetadataForSave()
      ApiClient.createElement(newElement, productCode, parentElementId)
        .then((element: Element) => {
          this.$emit('elementCreated', element)
          this.hideModal()
          this.clearForm()
          this.$store.dispatch(ActionTypes.SHOW_TOAST, {
            title: this.$t('upsert_element_modal_component.title_edit'),
            variant: 'success',
            message: this.$t('upsert_element_modal_component.feedback.success_insert') + ` ${element.name}`
          })
          this.$store.commit(MutationTypes.SET_LOADING, false)
        })
        .catch((ex) => {
          this.$store.dispatch(ActionTypes.SHOW_TOAST, {
            title: this.$t('upsert_element_modal_component.title_add'),
            variant: 'danger',
            message: `${ex.response.data.message}`
          })
          this.$store.commit(MutationTypes.SET_LOADING, false)
        })
    } else {
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('upsert_element_modal_component.title_add'),
        variant: 'danger',
        message: this.$t('feedback.error_message_generic')
      })
    }
  }

  private toggleDateCheck(value: boolean, field: string) {
    if (value) {
      // @ts-ignore
      Vue.set(this.newElement.metadata, field, moment().format('YYYY-MM-DD'))
    } else {
      // @ts-ignore
      Vue.set(this.newElement.metadata, field, '')
    }
  }

  private clearForm() {
    this.newElement.name = ''
    this.newElement.code = null
    this.newElement.type = ''
    this.clearRelations()
    this.clearWebpack()
    Vue.set(this.newElement, 'metadata', {})
    this.resetMetadata()
    this.visibleMetadata = true
    this.visibleRelation = false
  }

  private resetMetadata(elementTypeUpdated = false) {
    if (this.newElement.metadata === undefined) {
      return
    }

    const currentMetadata = this.newElement.metadata
    const newMetadata: any = {}

    newMetadata.startPage = this.showField('startPage') ? (elementTypeUpdated && currentMetadata.startPage != null ? currentMetadata.startPage : '0') : null
    newMetadata.endPage = this.showField('endPage') ? (elementTypeUpdated && currentMetadata.endPage != null ? currentMetadata.endPage : '0') : null
    newMetadata.nonCorrelativeNum = this.showField('nonCorrelativeNum') ? (elementTypeUpdated && currentMetadata.nonCorrelativeNum != null ? currentMetadata.nonCorrelativeNum : '') : null
    newMetadata.pagesNumber = this.showField('pagesNumber') ? (elementTypeUpdated && currentMetadata.pagesNumber != null ? currentMetadata.pagesNumber : '') : null
    newMetadata.filesNumber = this.showField('filesNumber') ? (elementTypeUpdated && currentMetadata.filesNumber != null ? currentMetadata.filesNumber : '') : null
    newMetadata.requireEC = this.showField('requireEC') ? (elementTypeUpdated && currentMetadata.requireEC != null ? currentMetadata.requireEC : false) : null
    newMetadata.typeNodeEc = this.showField('typeNodeEc') ? (elementTypeUpdated && currentMetadata.typeNodeEc != null ? currentMetadata.typeNodeEc : '') : null
    newMetadata.concept = this.showField('concept') ? (elementTypeUpdated && currentMetadata.concept != null ? currentMetadata.concept : '') : null
    newMetadata.contentIcons = this.showField('contentIcons') ? (elementTypeUpdated && currentMetadata.contentIcons != null ? currentMetadata.contentIcons : '') : null
    newMetadata.hasLdx = this.showField('hasLdx') ? (elementTypeUpdated && currentMetadata.hasLdx != null ? currentMetadata.hasLdx : false) : null
    newMetadata.size = this.showField('size') ? (elementTypeUpdated && currentMetadata.size != null ? currentMetadata.size : '') : null
    newMetadata.binding = this.showField('binding') ? (elementTypeUpdated && currentMetadata.binding != null ? currentMetadata.binding : '') : null
    newMetadata.coverDescription = this.showField('coverDescription') ? (elementTypeUpdated && currentMetadata.coverDescription != null ? currentMetadata.coverDescription : '') : null
    newMetadata.insideDescription = this.showField('insideDescription') ? (elementTypeUpdated && currentMetadata.insideDescription != null ? currentMetadata.insideDescription : '') : null
    newMetadata.endsheetsDescription = this.showField('endsheetsDescription') ? (elementTypeUpdated && currentMetadata.endsheetsDescription != null ? currentMetadata.endsheetsDescription : '') : null
    newMetadata.quantity = this.showField('quantity') ? (elementTypeUpdated && currentMetadata.quantity != null ? currentMetadata.quantity : '') : null
    newMetadata.manufacturing = this.showField('manufacturing') ? (elementTypeUpdated && currentMetadata.manufacturing != null ? currentMetadata.manufacturing : '') : null
    newMetadata.digitalFormat = this.showField('digitalFormat') ? (elementTypeUpdated && currentMetadata.digitalFormat != null ? currentMetadata.digitalFormat : '') : null
    newMetadata.observations = this.showField('observations') ? (elementTypeUpdated && currentMetadata.observations != null ? currentMetadata.observations : '') : null
    newMetadata.viewerType = this.showField('viewerType') ? (elementTypeUpdated && currentMetadata.viewerType != null ? currentMetadata.viewerType : '') : null
    newMetadata.requirementDate = this.showField('requirementDate') ? (elementTypeUpdated && currentMetadata.requirementDate != null ? currentMetadata.requirementDate : '') : null
    newMetadata.layoutStartDate = this.showField('layoutStartDate') ? (elementTypeUpdated && currentMetadata.layoutStartDate != null ? currentMetadata.layoutStartDate : '') : null
    newMetadata.finishedV1 = this.showField('finishedV1') ? (elementTypeUpdated && currentMetadata.finishedV1 != null ? currentMetadata.finishedV1 : false) : null
    newMetadata.v1Date = this.showField('v1Date') ? (elementTypeUpdated && currentMetadata.v1Date != null ? currentMetadata.v1Date : '') : null
    newMetadata.finishedFinalVersion = this.showField('finishedFinalVersion') ? (elementTypeUpdated && currentMetadata.finishedFinalVersion != null ? currentMetadata.finishedFinalVersion : false) : null
    newMetadata.finishedDate = this.showField('finishedDate') ? (elementTypeUpdated && currentMetadata.finishedDate != null ? currentMetadata.finishedDate : '') : null
    newMetadata.resourcesFinished = this.showField('resourcesFinished') ? (elementTypeUpdated && currentMetadata.resourcesFinished != null ? currentMetadata.resourcesFinished : false) : null
    newMetadata.isBlocked = this.showField('isBlocked') ? (elementTypeUpdated && currentMetadata.isBlocked != null ? currentMetadata.isBlocked : false) : null
    newMetadata.goToWebpack = this.showField('goToWebpack') ? (elementTypeUpdated && currentMetadata.goToWebpack != null ? currentMetadata.goToWebpack : false) : null
    newMetadata.reviewEdition = this.showField('reviewEdition') ? (elementTypeUpdated && currentMetadata.reviewEdition != null ? currentMetadata.reviewEdition : false) : null
    newMetadata.reviewMarketing = this.showField('reviewMarketing') ? (elementTypeUpdated && currentMetadata.reviewMarketing != null ? currentMetadata.reviewMarketing : false) : null
    newMetadata.isWebpackBook = this.showField('isWebpackBook') ? (elementTypeUpdated && currentMetadata.isWebpackBook != null ? currentMetadata.isWebpackBook : false) : null
    newMetadata.omitFileName = this.showField('omitFileName') ? (elementTypeUpdated && currentMetadata.omitFileName != null ? currentMetadata.omitFileName : false) : null
    newMetadata.systemFolder = this.showField('systemFolder') ? (elementTypeUpdated && currentMetadata.systemFolder != null ? currentMetadata.systemFolder : false) : null
    newMetadata.paginatedElement = this.showField('paginatedElement') ? (elementTypeUpdated && currentMetadata.paginatedElement != null ? currentMetadata.paginatedElement : false) : null
    newMetadata.workedAsFile = this.showField('workedAsFile') ? (elementTypeUpdated && currentMetadata.workedAsFile != null ? currentMetadata.workedAsFile : false) : null
    newMetadata.workedAsPdf = this.showField('workedAsPdf') ? (elementTypeUpdated && currentMetadata.workedAsPdf != null ? currentMetadata.workedAsPdf : false) : null
    newMetadata.quarter = this.showField('quarter') ? (elementTypeUpdated && currentMetadata.quarter != null ? currentMetadata.quarter : '') : null
    newMetadata.solutionsProvided = this.showField('solutionsProvided') ? (elementTypeUpdated && currentMetadata.solutionsProvided != null ? currentMetadata.solutionsProvided : false) : null

    // Preserve properties avoid in the list above (example) originCodsapWebpack, etc)
    Object.keys(currentMetadata).forEach(key => {
      if (!(key in newMetadata)) {
        newMetadata[key] = currentMetadata[key]
      }
    })

    Vue.set(this.newElement, 'metadata', newMetadata)
  }

  private getMetadataForSave() {
    const json = this.newElement.metadata as any

    for (const prop in json) {
      if (json[prop] == null) {
        delete json[prop]
      }
    }
    return json
  }

  private clearRelations() {
    this.productRelationSearch = null
    this.productRelationSearchArray = []
    this.elementRelationSearchArray = []
    this.newElement.elementRelationTo = null
    this.newElement.elementRelationType = ''
    this.newElement.elementRelationPercentage = null
  }

  private clearWebpack() {
    this.originCodsapWebpackSearchArray = []
    this.originElementWebpackSearchArray = []
    this.originCodsapCoverWebpackSearchArray = []
  }

  private getValidationState({ dirty, validated, valid = null }: any) {
    return dirty || validated ? valid : null
  }

  private getProductCode(): string {
    if (Utils.isProduct(this.selectedParent)) {
      return (this.selectedParent as Product).code
    }
    return (this.selectedParent as Element).product.code
  }

  private getParentElementId(): string {
    if (Utils.isElement(this.selectedParent)) {
      return this.selectedParent.id
    }
    return ''
  }

  private onSearchProduct(search: string, loading: any, field: string) {
    if (search.length > 2) {
      loading(true)
      this.searchProducts(search, loading, field)
    }
  }

  private productRelationSelect() {
    // Clear element relation selected and search
    this.elementRelationSearchArray = []
    this.newElement.elementRelationTo = null
  }

  private searchProducts(search: string, loading: any, field: string) {
    const searchOptions: SearchProductOptions = {
      search: search,
      offset: 0,
      limit: 10,
      educationLevel1: null,
      manager: null,
      type: null,
      country: null,
      workType: null,
      subject: null,
      productionCampaign: null,
      editorialProject: null,
      relatedToDigital: null,
      editorialProjectYearStart: null,
      language: null,
      educationLevel2: null
    }

    ApiClient.searchProducts(searchOptions)
      .then(async(result) => {
        if (this.FIELD_ELEMENT_RELATION_PRODUCT === field) {
          this.productRelationSearchArray = result.items
        } else if (this.FIELD_ORIGIN_CODSAP_WEBPACK === field) {
          this.originCodsapWebpackSearchArray = result.items
        } else if (this.FIELD_ORIGIN_CODSAP_COVER_WEBPACK === field) {
          this.originCodsapCoverWebpackSearchArray = result.items
        }
        loading(false)
      })
      .catch((e) => {
        loading(false)
        console.error('Error loading products', e)
      })
  }

  private onSearchElement(search: string, loading: any, field: string) {
    if (search.length > 2) {
      loading(true)
      this.searchElements(search, loading, field)
    }
  }

  private searchElements(search: string, loading: any, field: string) {
    const searchOptions: SearchElementOptions = {
      search: search,
      offset: 0,
      limit: 10,
      productId: null,
      productCode: null
    }

    if (this.FIELD_ELEMENT_RELATION_ELEMENT === field) {
      searchOptions.productId = this.productRelationSearch
    } else if (this.FIELD_ORIGIN_ELEMENT_WEBPACK === field && this.newElement.metadata) {
      searchOptions.productCode = this.newElement.metadata.originCodsapWebpack
    }

    ApiClient.searchElements(searchOptions)
      .then(async(result) => {
        if (this.FIELD_ELEMENT_RELATION_ELEMENT === field) {
          this.elementRelationSearchArray = result.items
        } else if (this.FIELD_ORIGIN_ELEMENT_WEBPACK === field) {
          this.originElementWebpackSearchArray = result.items
        }
        loading(false)
      })
      .catch((e) => {
        loading(false)
        console.error('Error loading elements', e)
      })
  }

  private loadProductRelationSearchArray(productCode: string) {
    ApiClient.getProduct(productCode)
      .then(async(result) => {
        this.productRelationSearchArray = [result]
        this.productRelationSearch = parseInt(result.id)
      })
      .catch((e) => {
        console.error('Error loading element', e)
      })
  }

  private loadElementRelationSearchArray(elementId: string) {
    ApiClient.getElement(elementId)
      .then(async(result) => {
        this.elementRelationSearchArray = [result]
      })
      .catch((e) => {
        console.error('Error loading element', e)
      })
  }

  private originCodsapWebpackSelect() {
    this.originElementWebpackSearchArray = []
    if (this.newElement.metadata && this.newElement.metadata.originElementWebpack && this.newElement.metadata.originElementWebpack !== '') {
      Vue.set(this.newElement.metadata, 'originElementWebpack', null)
    }
  }

  private loadOriginCodsapWebpackSearchArray(productCode: string) {
    ApiClient.getProduct(productCode)
      .then(async(result) => {
        this.originCodsapWebpackSearchArray = [result]
      })
      .catch((e) => {
        console.error('Error loading product webpack', e)
      })
  }

  private loadOriginElementWebpackSearchArray(elementId: string) {
    ApiClient.getElement(elementId)
      .then(async(result) => {
        this.originElementWebpackSearchArray = [result]
      })
      .catch((e) => {
        console.error('Error loading element', e)
      })
  }

  private loadOriginCodsapCoverWebpackSearchArray(productCode: string) {
    ApiClient.getProduct(productCode)
      .then(async(result) => {
        this.originCodsapCoverWebpackSearchArray = [result]
      })
      .catch((e) => {
        console.error('Error loading product cover webpack', e)
      })
  }

  private showField(field: string) {
    if (!field || !this.typeSelected || !this.typeSelected.metadataAllowed) {
      return false
    }

    const fieldsToFind = field.split(',')
    let showField = false
    for (const fieldToFind of fieldsToFind) {
      if (this.typeSelected.metadataAllowed.split(',').includes(fieldToFind)) {
        showField = true
        break
      }
    }
    return showField
  }

  private requiredField(field: string) {
    if (!field || !this.typeSelected || !this.typeSelected.metadataRequired) {
      return false
    }
    return this.typeSelected.metadataRequired.split(',').includes(field)
  }
}
